export default __webpack_public_path__ + "static/media/package-2.ea84a880.png";